import { GlobalControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { StartersDispensationStore } from '@hb/modules/applicants/starters-dispensation/starters-dispensation-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { ApplicantsStoreService } from '@hb/modules/applicants/applicants-store.service';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { distinctUntilChanged, skip } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';

import { StartersDispensation } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule } from '@ap/content';
import { ApButtonGroupComponent, ApButtonGroupItemComponent } from '@ap/button';

@Component({
    selector: 'starters-dispensation-button',
    templateUrl: './starters-dispensation-button.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, ApButtonGroupItemComponent, ApButtonGroupComponent],
    providers: [
        { provide: GLOBAL_STORE, useExisting: StartersDispensationStore },
        { provide: QUESTION_KEY, useValue: QuestionKey.INCOME_STARTERS_DISPENSATION }
    ]
})
export class StartersDispensationButtonComponent extends GlobalInjectComponent<StartersDispensationStore> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(StartersDispensationStore);
    protected readonly applicantStore = inject(ApplicantsStoreService);

    protected readonly startersDispensation = StartersDispensation;

    mainApplicantQualifyForStartersDispensation: boolean;
    coApplicantQualifyForStartersDispensation = false;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new GlobalControl<StartersDispensation>(
            this.analyticsService,
            this.questionKey,
            this.store.getStartersDispensation()
        );
        this.mainApplicantControl
            .onUpdate()
            .subscribe((startersDispensationOption) => this.store.setStartersDispensation(startersDispensationOption));
        this.applicantStore
            .getMainApplicantDetails()
            .subscribe((details) => (this.mainApplicantQualifyForStartersDispensation = details?.starter_dispensation));
        this.applicantStore
            .getCoApplicantDetails()
            .subscribe((details) => (this.coApplicantQualifyForStartersDispensation = details?.starter_dispensation));
        this.store
            .getHasCoApplicant()
            .pipe(distinctUntilChanged(), skip(1))
            .subscribe((hasCoApplicant) => {
                this.mainApplicantControl.setValue(null);
                if (!hasCoApplicant) {
                    this.coApplicantQualifyForStartersDispensation = false;
                }
            });
    }

    onButtonGroupClicked($event: string): void {
        this.mainApplicantControl.setValue($event);
    }

    showOptionsForBothApplicants() {
        return this.mainApplicantQualifyForStartersDispensation && this.coApplicantQualifyForStartersDispensation;
    }

    showOptionsForMainApplicantOnly() {
        return this.mainApplicantQualifyForStartersDispensation && !this.coApplicantQualifyForStartersDispensation;
    }

    showOptionsForCoApplicantOnly() {
        return !this.mainApplicantQualifyForStartersDispensation && this.coApplicantQualifyForStartersDispensation;
    }
}
